export enum VenueTransactionStatus {
  IN_PROGRESS = 'in_progress',
  PENDING = 'pending',
  PROCESSED = 'processed',
  PAID = 'paid',
}
